// src/pages/SearchResults.js
import React from 'react';

const SearchResults = () => (
  <div>
    <h1>Search Results</h1>
    <p>Here are your search results.</p>
  </div>
);

export default SearchResults;
